// Single source of truth for the headline portfolio numbers. These appear in
// the hero, About, page metadata, the homepage stat strip, and the projects
// page — update them HERE and every surface stays in sync. (Before this, the
// hero/metadata claimed "8 live products" while the stat strip said "6 Live
// Products"; the 2026-06-13 audit flagged the self-contradiction as the
// highest-ROI trust fix.)
//
// Rule: PRODUCTS_TOTAL = PRODUCTS_LIVE + everything still launching. Any
// summary sentence that uses the word "live" must use PRODUCTS_LIVE only;
// "shipped / built / production applications" use PRODUCTS_TOTAL.

/** Total production applications shipped (live + launching). */
export const PRODUCTS_TOTAL = 8;

/** Products that are live with real users today. "live" copy uses this only. */
export const PRODUCTS_LIVE = 6;

/** Distinct industries served. */
export const INDUSTRIES = 5;

/** Headline delivery window. */
export const WEEKS_TO_SHIP = '2–6';

/** Lowest real starting price (must match the lowest Services tier). */
export const STARTING_PRICE = '$2,500';
